import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-errorcodelist",
  templateUrl: "./errorcodelist.component.html",
  styleUrls: ["./errorcodelist.component.scss"]
})
export class ErrorcodelistComponent implements OnInit {
  constructor(
    private router: Router,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  isLoading = false;
  isError = false;
  errorMessage = "";
  errorcode: any;
  dataSource: any[] = [];
  displayedColumns: string[] = [
    "action",
    "errorcode",
    "httpstatus",
    "message",
    "severity",
    "loglevel"
  ];
  mode = "";

  ngOnInit() {
    this.getAllErrorCode();
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  cancel() {
    this.router.navigateByUrl("/home");
  }
  new() {
    this.router.navigateByUrl("/home/errorcode/new");
  }
  getAllErrorCode() {
    console.log("getAllErrorCode called");

    const organizationid = localStorage.getItem("crm_orgid");

    const domain = localStorage.getItem(`${organizationid}.domain`);

    const subdomain = localStorage.getItem(`${organizationid}.subdomain`);

    this.isLoading = true;
    this.isError = false;

    this.dataService
      .getAllErrorCode(domain, subdomain, organizationid)
      .subscribe(
        (res: any) => {
          console.log("Full API Response:", res);

          if (res && res.success === 1 && res.data.errorcode) {
            const errorList = res.data.errorcode;

            this.dataSource = errorList.map((item: any) => ({
              id: item.id,
              errorcode: item.errorcode,
              httpstatus: item.httpstatus,
              message: item.message,
              severity: item.severity,
              loglevel: item.loglevel
            }));

            console.log("Mapped DataSource:", this.dataSource);
          } else {
            this.isError = true;
            this.errorMessage = "No data found";
          }

          this.isLoading = false;
        },
        (err) => {
          console.error("API Error:", err);
          this.isError = true;
          this.errorMessage = err.message || "Something went wrong";
          this.isLoading = false;
        }
      );
  }

  editApp(element: any) {
    this.router.navigateByUrl("/home/errorcode/edit/" + element.id);
  }

  delete(id: any, type: any) {
    // alert(id)
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService.deleteErrorCode(id, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")

          this.showSuccess(res.message);
          this.isLoading = false;

          window.location.reload();
        } else {
          console.log("Failed to delete!");
          this.isLoading = false;
          this.showError(res.message);
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.showError(err.message);
      }
    );
  }
}
